import Api from '@api/instance';
import { ProvisioningProfileDevice } from '@models/provisioning-profile-devices';
import { ProvisioningProfile } from '@models/provisioning-profile.model';
import { Page } from '@testsigma/organism';
import axios from 'axios';
import { useInfiniteQuery } from 'react-query';
import { PROVISIONING_PROFILES_INFINITE_QUERY_KEY } from '../constants';
import { mapUserDetails } from '../utils';
import { getNextPageParam } from '@hooks/use-react-query-caching';

const namespace = '/settings/provisioning_profiles';

const findAll = (query?: string, page?) => {
  return Api.get(namespace, {
    query: query ? 'name:*' + query + '*' : undefined,
    page,
  })
    .then((data) => {
      return data;
    })
    .catch(() => {
      throw new Error('Problem while fetching All Provisioning_profile');
    });
};
const remove = (id: number) => {
  return Api.remove(`${namespace}/${id}`)
    .then(() => {})
    .catch(() => {
      throw new Error('Problem while fetching All Provisioning_profile');
    });
};
const create = (provisionProfile: ProvisioningProfile) => {
  return Api.post(namespace, provisionProfile.serialize())
    .then((data) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
};
const update = (
  provisioningProfile: ProvisioningProfile,
  formData: FormData,
) => {
  return axios
    .put(namespace + '/' + provisioningProfile.id, formData, {
      headers: { 'content-type': 'multipart/form-data' },
    })
    .then((data) => {
      return data;
    })
    .catch((e) => {
      throw e;
    });
};
const show = (id: any) => {
  return Api.get(namespace + '/' + id)
    .then((res) => {
      return new ProvisioningProfile().deserialize(res);
    })
    .catch((e) => {
      throw e;
    });
};
const findAllProvisioningDevices = (query: string) => {
  return Api.get(namespace + '/provisioned_devices?query=' + query)
    .then((data) => {
      return new Page<ProvisioningProfileDevice>().deserialize(
        data,
        ProvisioningProfileDevice,
      );
    })
    .catch((e) => {
      throw e;
    });
};
const ProvisioningProfileService = {
  findAll,
  create,
  update,
  remove,
  show,
  findAllProvisioningDevices,
};

export const useGetAllProvisioningProfiles = (searchQuery = '') => {
  const fetchProvisioningProfiles = async ({ pageParam = 0 }) => {
    const data: Page<ProvisioningProfile> = await findAll(
      searchQuery,
      pageParam,
    );
    if (data?.content) {
      await mapUserDetails(data?.content);
    }
    return data;
  };

  return useInfiniteQuery({
    queryKey: `${PROVISIONING_PROFILES_INFINITE_QUERY_KEY}-${searchQuery}`,
    queryFn: fetchProvisioningProfiles,
    getNextPageParam,
    staleTime: 0,
    cacheTime: 0,
  });
};

export default ProvisioningProfileService;
